<template>
    <header>
        <div class="container">
            <div class="header-text " >
                <div class="name">{{name}}</div>
                <div class="body" v-html="body"></div>
            </div>
            <img class="zaidoun" :src="'https://cms.zaidounk.com/'+zaidounImage" alt="">
        </div>
    </header>
</template>

<script>
export default {
    data () {
        return {
        name: '',
        body: '',
        zaidounImage: ''
        }
    },
    methods: {
    },
    created () {
    this.$http.get('https://cms.zaidounk.com/api/header')
    .then(result => {
        return result.json()
    })
    .then(data => {
        this.name = data[0].name
        this.body = data[0].body
        this.zaidounImage = data[0].zaidounImage
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/Header.vue